<div class="modal-header">
  <h5 class="modal-title">
    <i class="cs-icon cs-icon-upload"></i><ng-container>&nbsp;</ng-container
    ><ng-container i18n>Import Hold Events from CSV Files</ng-container>
  </h5>
  <button (click)="onClose()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <app-csv-file-parser
    [columnDefs]="columnDefs"
    [guide]="guide"
    (parsed)="onCsvFilesParsed($event)"
  ></app-csv-file-parser>
</div>
<div class="modal-footer">
  <button (click)="onClose()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Cancel</ng-container>
  </button>
  <button
    (click)="onCreate()"
    [disabled]="!files?.length || hasErrors()"
    type="button"
    class="btn btn-secondary-info create-btn"
  >
    <i class="cs-icon cs-icon-upload"></i> <ng-container i18n>upload</ng-container>
  </button>
</div>
